export enum ContactConfigurationTypeEnum {
    None = 0,

    OneRequired = 1,

    OneVerified = 2,

    AllVerified = 3,

    OneRequiredAllVerified = 4,
}
